import Repository from './Repository';
const resource = '/content/article';

export default {
  get(queryString = '') {
    return Repository.get(`${resource}${queryString}`);
  }
};
